import React, { useCallback, useEffect, useState,useMemo } from "react";
import {
  useTheme,
  Container,
  Box,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { apps, LOCAL_STORAGE_GRID_KEYS } from "../../../_constants";
import { formatDate, getLocalStorageItem, setLocalStorageItem } from "../../../_helpers";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import DataGridV2 from "../../../components/DataGridV2";
import { INITIAL_ROW_SELECTION_MODEL } from "../../../components/DataGridV2/constants";
import { getCategories, getSlotsGenerations } from "../../../apis/agendaApis";
import { useHistory } from 'react-router-dom/';
import { Add } from "@mui/icons-material";
import { getGenerationListColumns } from "./generationListUtils";

const GenerationList = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const { selected , rights} = useSelector(state => state.buildings)
  const app = useSelector((state) => state.app);
  const { t , i18n } = useTranslation();
  const apiRef = useGridApiRef();
  const keyPrefix = app === apps.huisinfo ? "BUYERS_GUIDE" : "GENERAL";
  const [generationList, setGenerationList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
    LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_PAGINATION[keyPrefix], undefined
  ))

  const onPaginationModelChange = useCallback((newPaginationModel) => {
    setPaginationModel(newPaginationModel)
    setLocalStorageItem(
      LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_PAGINATION[keyPrefix],
      newPaginationModel
    );
  }, [keyPrefix])

const getGenerationList = async () => {
    if (!selected?.projectId) {
      setGenerationList([]); 
      return;
    }
    
      setLoading(true);
      const list = await getSlotsGenerations(selected.projectId)

      if (list && list.data && list.data.length > 0) {
          setGenerationList(list.data.map(x => ({  ...x, status: x.completionDate ? t("general.published") : t("general.draft"), id: x.generationId, objects:  x.completionDate ?`${x?.confirmedAppointmentsCount}/${x?.buildingIds?.length}` : x?.buildingIds?.length})));
      } else {
          setGenerationList([])
      }
      setLoading(false)
  }


  const getAgendaCategories = async () => {
    const categories = await getCategories();
    setCategories(categories?.data);
  }

  useEffect(() => {
      getAgendaCategories();
  }, []);

 useEffect(() => {
      getGenerationList();
  }, [selected?.projectId]);

  const handleAddButtonClick = useCallback(() => {
    history.push('/agenda/maak');
  }, [history]);

  const getToolbarProps = useMemo(() => {
    return {
      toolbarStartActions: [
        {
          title: t("general.add"),
          icon: Add,
          disabled: !rights?.["agenda.canCreateAgenda"],
          onClick: handleAddButtonClick
        }
      ],
    };
  }, [t, rights, handleAddButtonClick]);
 
    const getTaskGenerationListForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
    const userSelectedRows = isAllSelected ? generationList: idsToExport.map(id => generationList.find(item => item?.id === id));
    const results = userSelectedRows?.map(item => {
    const result = {};
    Object.keys(item).forEach(key => {
      let value = item[key];
      const columnDef = columns.find(col => col.field === key);
      const columnType = columnDef?.type;

      if (columnType === 'dateTime') {
        value = value ? formatDate(new Date(value), true) : "";
      }
      result[key] = value;
    });

    return result;
  });

  return results;
};

const statusOptions = [
  ...new Set(generationList.map((item) => item.status))
];

 const columns = getGenerationListColumns({t,theme,keyPrefix,i18n,apiRef,categories,statusOptions})
 

  return (
    
       <Container maxWidth={false} className={classes.mainContainer}>
         <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
              <Box p={2}  >
                <Typography variant='h6'>{t("agenda.timeSlots")}</Typography>
                </Box>
            <Box  sx={{ flex: 1, minHeight: 0 }}>
          <DataGridV2
            localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_SEARCH_TEXT[keyPrefix]}
            localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_COLUMN_FILTER[keyPrefix]}
            localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_COLUMN_SORT[keyPrefix]}
            localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_COLUMN_ORDER[keyPrefix]}
            localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_COLUMN_WIDTH[keyPrefix]}
            localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.AGENDA_GENERATION_LIST_COLUMN_VISIBILITY[keyPrefix]}
            apiRef={apiRef}
            loading={loading}
            rows={generationList}
            columns={columns}
            pagination
            checkboxSelection
            {...(!!paginationModel && { paginationModel })}
            onPaginationModelChange={onPaginationModelChange}
            toolbarProps={{
              ...getToolbarProps,
              title: t("general.object.select"),
              selectedRows: rowSelectionModel,
              getData: getTaskGenerationListForPrintAndDownload,
            }}
            filterMode="client"
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
          }}
          onCellClick={(params, event) => {
          if (params.field === "__check__") {
            return;
          }
          const { field, row } = params;
          const generationId = row?.id;
          if (field === "objects" && row?.completionDate) {
            history.push(`/agenda/tijdsloten/${generationId}`);
          } else {
            history.push({ pathname: "/agenda/maak", state: { generationId } });
          }
        }}
          />
          </Box>
          |</Box>
      </Container>
  

  );
};

export default GenerationList;

const useStyles = makeStyles((theme) => ({
        mainContainer: {
        height: "100%",
        width: "100%",
        overflow: "auto",
        padding: 0,

    },
}));
